/* globals MathJax */

/* eslint-disable new-cap */
import thirdParties from 'js/lib/thirdParties';

import { mathJaxConfig21 } from './__data__/MathJaxConfig';

let initialized = false;

const mathJaxCB = function (cb) {
  return function () {
    if (initialized) {
      return cb();
    }

    initialized = true;

    // http://docs.mathjax.org/en/latest/configuration.html
    MathJax.Hub.Config(mathJaxConfig21);
    MathJax.Hub.Configured();
    return cb();
  };
};

export default {
  render(dom, cb) {
    const callback = mathJaxCB(function () {
      setTimeout(function () {
        if (dom) {
          MathJax.Hub.Queue(['Typeset', MathJax.Hub, dom], cb);
          MathJax.Hub.Queue(['Rerender', MathJax.Hub, dom], cb);
        } else {
          MathJax.Hub.Queue(['Typeset', MathJax.Hub], cb);
          MathJax.Hub.Queue(['Rerender', MathJax.Hub], cb);
        }
      }, 1);
    });

    thirdParties.ready('MathJax', callback);
  },
};
